import { createContext, useContext, useMemo, useState } from "react";

function buildFinancialYears() {
  const today = new Date();
  const month = today.getMonth() + 1;
  const fyStartYear = month >= 4 ? today.getFullYear() : today.getFullYear() - 1;
  const current = {
    key: `FY-${fyStartYear}-${fyStartYear + 1}`,
    label: `Present FY ${fyStartYear}-${String(fyStartYear + 1).slice(-2)}`,
    fromDate: `${fyStartYear}-04-01`,
    toDate: `${fyStartYear + 1}-03-31`,
    type: "present",
  };
  const previous = {
    key: `FY-${fyStartYear - 1}-${fyStartYear}`,
    label: `Previous FY ${fyStartYear - 1}-${String(fyStartYear).slice(-2)}`,
    fromDate: `${fyStartYear - 1}-04-01`,
    toDate: `${fyStartYear}-03-31`,
    type: "previous",
  };
  return [current, previous];
}

const FinancialYearContext = createContext(null);

export function FinancialYearProvider({ children }) {
  const years = useMemo(buildFinancialYears, []);
  const savedKey = localStorage.getItem("financialYearKey");
  const [financialYearKey, setFinancialYearKey] = useState(savedKey || years[0].key);
  const financialYear = years.find((x) => x.key === financialYearKey) || years[0];

  const changeFinancialYear = (key) => {
    localStorage.setItem("financialYearKey", key);
    setFinancialYearKey(key);
  };

  return (
    <FinancialYearContext.Provider value={{ years, financialYear, financialYearKey, changeFinancialYear }}>
      {children}
    </FinancialYearContext.Provider>
  );
}

export function useFinancialYear() {
  const ctx = useContext(FinancialYearContext);
  if (!ctx) throw new Error("useFinancialYear must be used inside FinancialYearProvider");
  return ctx;
}
